<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;font-weight: bolder">
  {{'notification_cms.title' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <mat-list-item *ngFor="let noitification of notifications">
    <div class="content-notificaion" [innerHTML]="(noitification.content)|noSanitize"></div>
<!--    <div mat-line style="padding-top: 10px" *ngIf="noitification?.status + '' === '0'">-->
<!--    </div>-->
    <mat-divider></mat-divider>
  </mat-list-item>
  <mat-checkbox *ngIf="checkEnable()" [(ngModel)]="motiNextTime">{{"notification_cms.check"|translate}}</mat-checkbox>
</mat-dialog-content>

<div mat-dialog-actions class="justify-content-center">
  <button class="ml-2" (click)="onClose()" mat-raised-button color="primary" type="button">
    <mat-icon class="mr-0">done</mat-icon>{{'button.close' | translate}}
  </button>
</div>
